import { Grid, Paper, Button } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import useReactHookForm from "hooks/useReactHookForm";
import ContentRight from "shared/molecules/content-right";
import { hasAtLeastOneValue, sessionUsagesInitialValues, sessionUsagesProperties, sessionUsagesValidationSchema } from "./helper";
import { formatDateUtc } from "utils/time-util/utcIstTime";

export function SessionUsagesFilter({setSearchPayload,
  setPage,
  }) {

  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    sessionUsagesInitialValues,
    sessionUsagesValidationSchema,
    "",
  );
  
  const handleSearch =()=>{

    const payload:any={};
    
    const projectIds= watch("projectIds");
    if(projectIds) payload.projectIds=projectIds;

    const entityType= watch("entityType");
    if(entityType) payload.entityType=entityType;

    // const entityId= watch("entityId");
    // if(entityId) payload.entityId=entityId;

    const isActive= watch("isActive");
    if (isActive === "true") payload.isActive = true;
    else if (isActive === "false") payload.isActive = false;

    const hasAttended= watch("hasAttended");
    if (hasAttended === "true") payload.hasAttended = true;
    else if (hasAttended === "false") payload.hasAttended = false;

    const joinedAt = watch("joined_at");
    if(joinedAt?.[0]) payload.joinedFrom=formatDateUtc(joinedAt[0]);
    if(joinedAt?.[1]) payload.joinedTill=formatDateUtc(joinedAt[1], true);

    const leftAt = watch("left_at");
    if(leftAt?.[0]) payload.leftFrom=formatDateUtc(leftAt[0]);
    if(leftAt?.[1]) payload.leftTill=formatDateUtc(leftAt[1], true);

    const createdAt = watch("created_at");
    if (createdAt?.[0]) payload.createdFrom = formatDateUtc(createdAt[0]);
    if (createdAt?.[1]) payload.createdTill = formatDateUtc(createdAt[1], true);

    const updatedAt = watch("updated_at");
    if(updatedAt?.[0]) payload.updatedFrom=formatDateUtc(updatedAt[0]);
    if(updatedAt?.[1]) payload.updatedTill=formatDateUtc(updatedAt[1], true);

    setSearchPayload(payload);
    setPage(1);
  }

  const clearFilter = () =>{
    setValue("projectIds","")
    setValue("entityType","")
    setValue("hasAttended","")
    setValue("isActive","")
    setValue("created_at",[null, null]);
    setValue("updated_at",[null, null]);
    setValue("joined_at",[null, null])
    setValue("left_at",[null, null])
    setSearchPayload({});
    setPage(1);
  }

  return (
    //
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt:3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={sessionUsagesProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -1 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(),["projectIds", "entityType","hasAttended","isActive","joined_at", "left_at", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), ["projectIds", "entityType","hasAttended","isActive","joined_at", "left_at", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
